'use strict';

angular.module('licensure.portal')
    .directive('portalCopyright', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'components/copyright/copyright.html',
            controller: ['$scope', function ($scope) {
                $scope.currentYear = (new Date()).getFullYear();
            }],
            replace: true,
            link: function (scope, elem, attrs, ctrl) {
            }
        };
    }])
;